<div class="c-modal display-block" role="dialog">
    <img class="recite-link" alt="accessibility tools" (click)="loadRecite()" src="/images/Standard _ Small _ Squared _ Red _ Option 3.svg">
    <div class="c-modal__content">

        <div class="c-modal-top-nav">
            <div class="c-modal-top-nav__logo">
                <svg class="c-ic-purple c-modal-top-nav__logo-img">
                    <use xlink:href="#ic-logo-2" href="#ic-logo-2"></use>
                </svg>
            </div>
            <button class="c-ic-button c-modal-top-nav__close" role="button" aria-label="close" id="interrupt-dismiss-button" (click)="close()">
                <svg class="c-ic c-ic--sm">
                    <use xlink:href="#ic-close" href="#ic-close"></use>
                </svg>
            </button>
        </div>

        <div class="c-mia-modal">
            <div class="mia-modal-img">
                <img class="c-banner__mia c-banner__mia--modal c-mia-img" alt="Minster law logo" src="/images/Mia.svg">
            </div>
        </div>

        <div class="c-modal__content__body c-mia-modal-body">
            <div>
                <p class="c-text-width c-text-dark"><b>Your INK Account Has Been Deactivated</b></p>
                <p class="c-text-width c-text-dark">Your claim is now being handled outside the small claims process, it’s no longer appropriate to manage it through the INK portal. Any documents you uploaded are safely stored on our system and your dedicated team is here to help.</p>
                <p class="c-text-width c-text-dark">Their contact information is</p>
                <p class="c-text-width c-text-dark">{{case.fileHandler.name}}</p>
                <p class="c-text-width c-text-dark">{{case.fileHandler.phoneNumber}}</p>
                <p class="c-text-width c-text-dark">{{case.fileHandler.emailAddress}}</p>
                <p class="c-text-width c-text-dark">Thank you for your understanding.</p>
            </div>
        </div>
    </div>
</div>
